module.exports = __webpack_public_path__ + "static/media/bytt-no-16.0ecc3470.mp3";